import React from 'react';
import { Phone, Mail, MapPin, ChevronRight, ShoppingBag, ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const {
    t
  } = useLanguage();
  return <footer className="bg-brand-black text-white pt-16 pb-8 border-t-4 border-brand-gold" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-8 mb-12" data-id="element-86">
          {/* Brand Column */}
          <div className="md:col-span-5 lg:col-span-4" data-id="element-87">
            <div className="flex items-center gap-4 mb-6" data-id="element-88">
              <div className="h-20 w-20 rounded bg-black overflow-hidden flex-shrink-0" data-id="element-89">
                <img src="https://cdn.magicpatterns.com/uploads/iYwSJn6f4bZdGuVT15Hcgi/logo.jpg" alt="JOM Elite Construction LLC Logo" className="h-full w-full object-cover" data-id="element-90" />
              </div>
              <div data-id="element-91">
                <span className="block text-brand-gold font-serif font-bold text-2xl leading-none tracking-wide" data-id="element-92">
                  JOM ELITE
                </span>
                <span className="block text-white/80 text-sm tracking-widest mt-1" data-id="element-93">
                  CONSTRUCTION LLC
                </span>
              </div>
            </div>
            <p className="text-white/70 text-lg font-serif italic mb-6" data-id="element-94">
              {t('footer.tagline')}
            </p>
            <div className="inline-block bg-white/5 border border-white/10 rounded px-4 py-2 text-sm text-white/60" data-id="element-95">
              {t('footer.reg')}
              <br data-id="element-96" />
              <span className="text-white/40 text-xs" data-id="element-97">{t('footer.file')}</span>
            </div>
          </div>

          {/* Links Column */}
          <div className="md:col-span-3 lg:col-span-4 flex flex-col sm:flex-row gap-12 lg:justify-center" data-id="element-98">
            <div data-id="element-99">
              <h4 className="text-brand-gold font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-100">
                {t('footer.nav')}
              </h4>
              <ul className="space-y-3" data-id="element-101">
                {[{
                name: t('nav.inicio'),
                href: 'inicio'
              }, {
                name: t('nav.problema'),
                href: 'problema'
              }, {
                name: t('nav.sistema'),
                href: 'sistema'
              }, {
                name: t('nav.nosotros'),
                href: 'nosotros'
              }, {
                name: t('nav.garantia'),
                href: 'garantia'
              }, {
                name: t('nav.faq'),
                href: 'faq'
              }].map(item => <li key={item.name} data-id="element-102">
                    <a href={`#${item.href}`} className="text-white/70 hover:text-brand-gold transition-colors flex items-center gap-1 group" data-id="element-103">
                      <ChevronRight className="w-3 h-3 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-104" />
                      {item.name}
                    </a>
                  </li>)}
              </ul>

              {/* Tienda Online callout */}
              <a href="https://www.jomelitesupply.com/" target="_blank" rel="noopener noreferrer" className="mt-6 group flex items-center gap-3 bg-brand-gold/10 hover:bg-brand-gold/20 border border-brand-gold/30 hover:border-brand-gold rounded-lg p-3 transition-all" data-id="element-105">
                <div className="bg-brand-gold/20 p-2 rounded" data-id="element-106">
                  <ShoppingBag className="w-4 h-4 text-brand-gold" data-id="element-107" />
                </div>
                <div className="flex-1" data-id="element-108">
                  <span className="block text-brand-gold font-bold text-sm" data-id="element-109">
                    {t('nav.tiendaOnline')}
                  </span>
                  <span className="block text-white/60 text-xs" data-id="element-110">
                    jomelitesupply.com
                  </span>
                </div>
                <ArrowUpRight className="w-4 h-4 text-brand-gold group-hover:rotate-45 transition-transform" data-id="element-111" />
              </a>
            </div>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-4 lg:col-span-4" data-id="element-112">
            <h4 className="text-brand-gold font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-113">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-4" data-id="element-114">
              <li data-id="element-115">
                <a href="tel:8137534656" className="flex items-start gap-3 text-white/80 hover:text-brand-gold transition-colors group" data-id="element-116">
                  <div className="bg-white/5 p-2 rounded group-hover:bg-brand-gold/20 transition-colors" data-id="element-117">
                    <Phone className="w-5 h-5 text-brand-gold" data-id="element-118" />
                  </div>
                  <div data-id="element-119">
                    <span className="block text-sm text-white/50 mb-0.5" data-id="element-120">
                      {t('footer.call')}
                    </span>
                    <span className="font-semibold text-lg" data-id="element-121">813-753-4656</span>
                  </div>
                </a>
              </li>
              <li data-id="element-122">
                <a href="mailto:jomeliteconstruction@gmail.com" className="flex items-start gap-3 text-white/80 hover:text-brand-gold transition-colors group" data-id="element-123">
                  <div className="bg-white/5 p-2 rounded group-hover:bg-brand-gold/20 transition-colors" data-id="element-124">
                    <Mail className="w-5 h-5 text-brand-gold" data-id="element-125" />
                  </div>
                  <div data-id="element-126">
                    <span className="block text-sm text-white/50 mb-0.5" data-id="element-127">
                      {t('footer.write')}
                    </span>
                    <span className="font-medium break-all" data-id="element-128">
                      jomeliteconstruction@gmail.com
                    </span>
                  </div>
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/80" data-id="element-129">
                <div className="bg-white/5 p-2 rounded" data-id="element-130">
                  <MapPin className="w-5 h-5 text-brand-gold" data-id="element-131" />
                </div>
                <div data-id="element-132">
                  <span className="block text-sm text-white/50 mb-0.5" data-id="element-133">
                    {t('footer.location')}
                  </span>
                  <span className="font-medium" data-id="element-134">
                    {t('footer.locDesc')}
                    <br data-id="element-135" />
                    US Latino Market
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-136">
          <p className="text-white/40 text-sm text-center md:text-left" data-id="element-137">
            &copy; {currentYear} JOM Elite Construction LLC.{' '}
            {t('footer.rights')}
          </p>
          <p className="text-white/30 text-xs" data-id="element-138">{t('footer.design')}</p>
        </div>
      </div>
    </footer>;
}